import ConnectContainer from './ConnectContainer';
import { watchConnectActions } from './Connect.saga';

export default [
  {
    path: '/connect/my-time',
    isPublic: true,
    component: ConnectContainer,
    pathSagas: [watchConnectActions],
  },
];
